import { createContext, useContext } from "react";

// The ScrollArea viewport rendered by ComboboxContent, so a virtualized list
// deep in the tree can scroll on it instead of nesting its own scroller.
export const ComboboxScrollContext = createContext<HTMLDivElement | null>(null);

export function useComboboxScrollElement(): HTMLDivElement | null {
  return useContext(ComboboxScrollContext);
}
